// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WelfareItem_wrapper__JDcgr","content":"WelfareItem_content__ZD0G8","wireframe":"WelfareItem_wireframe__6ztdc"};